import { Grid, Skeleton, Typography, useMediaQuery } from "@mui/material";
import { Box, Container } from "@mui/system";
import axios from "axios";
import React, { useEffect, useState } from "react";
import SliderCard from "../posts/SliderCard";
import Slider from "react-slick";
import "../index.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useLocation, useParams } from "react-router-dom";

export default function LatestInsights({ page, pageData }) {
  const { slug } = useParams();
  const mobile = useMediaQuery((theme) => theme.breakpoints.down("md"));

  const location = useLocation();
  const [posts, setPosts] = useState();
  const [categories, setCategories] = useState();
  const [topics, setTopics] = useState();
  const [currentSlide, setCurrentSlide] = useState(0);
  const [slidesToShow, setSlidesToShow] = useState(3);
  const [isDragging, setIsDragging] = useState(false);

  useEffect(() => {
    if (pageData?.acf?.topics && pageData?.acf?.topics.length > 0) {
      const topicsArray = pageData?.acf?.topics;
      // console.log('topicsArray', topicsArray);

      // Check if the topicsArray is defined and not empty
      if (
        topicsArray &&
        (Array.isArray(topicsArray)
          ? topicsArray.length > 0
          : Object.keys(topicsArray).length > 0)
      ) {
        // console.log('topicsArray', topicsArray);

        // Determine if topicsArray is an array or an object and convert it to a uniform array format
        const selectedTopics = Array.isArray(topicsArray)
          ? topicsArray
          : Object.keys(topicsArray).map((key) => topicsArray[key]);

        // Extract the term_id values and set the topics
        setTopics(selectedTopics.map((topic) => topic.term_id));

        // console.log('topics', selectedTopics.map(topic => topic.term_id));
      }
    }
  }, [pageData?.acf?.topics]);

  useEffect(() => {
    const apiEndpoint = WP_API_Settings.endpoint + "wp/v2/posts";
    const apiCategories = WP_API_Settings.endpoint + "wp/v2/categories";

    // Get the categories
    axios.get(apiCategories).then((response) => {
      if (response.data) {
        // console.log('apiCategories', response.data);

        setCategories(response.data);
      }
    });
    // Check if consulting is true before adding the category filter
    let apiParams = "?per_page=9&_embed=true";
    if (location.pathname === "/services/consulting/") {
      // apiParams = '?per_page=9&_embed=true&categories=28';
      apiParams = "?per_page=9&_embed=true&topic=123";
    } else {
      //exclude the webinars
      apiParams = "?per_page=9&_embed=true&categories_exclude=28";
      // console.log('topics***', topics);
      if (topics && topics.length > 0) {
        // console.log('topics***', topics);
        apiParams = "?per_page=9&_embed=true&topic=" + topics.join(",");
      }
    }

    axios.get(apiEndpoint + apiParams).then((response) => {
      if (response.data) {
        // Filter the posts to only show the posts that are in the relevant category
        const relevantPosts = response.data.filter((post) => {
          return post.categories.includes(28);
        });

        // console.log('apiPosts', response.data);

        setPosts(response.data);
      }
    });
  }, [page, topics, location]); // Add consulting to the dependency array to react to changes in its value

  const handleDragStart = () => {
    setIsDragging(true);
  };

  const handleDragEnd = () => {
    setIsDragging(false);
  };

  //Slider config
  const settings = {
    dots: false,
    infinite: true,
    arrows: true,
    autoplay: true,
    autoplaySpeed: 3000,
    slidesToShow: slidesToShow,
    slidesToScroll: 1,
    beforeChange: (corrent, next) => {
      setCurrentSlide(next);
      handleDragStart();
    },
    afterChange: () => handleDragEnd(),
  };

  //Observe window resize
  useEffect(() => {
    function handleResize() {
      setSlidesToShow(window.innerWidth < 600 ? 1 : 3);
    }
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <>
      {posts && posts.length > 0 ? (
        <Container
          maxWidth="xl"
          id="insights"
          sx={{
            m: "4rem auto 2rem auto",
          }}
        >
          <Typography
            variant="h3"
            sx={{
              mb: "2rem",
              fontSize: "1.6rem",
              color: "#005EAA",
            }}
          >
            Latest Insights
          </Typography>
          <>
            <Slider {...settings}>
              {posts.map((post) => {
                return (
                  <Box
                    sx={{
                      p: "0 1rem",
                    }}
                  >
                    <SliderCard post={post} isDragging={isDragging} />
                  </Box>
                );
              })}
            </Slider>
            <div
              style={{
                marginTop: "1rem",
                width: "100%",
                height: "10px",
                backgroundColor: "#E8E8E8",
              }}
            >
              <div
                style={{
                  width: `${((currentSlide + 1) / posts.length) * 100}%`,
                  height: "100%",
                  backgroundColor: "#0C5EAA",
                  transition: "width 0.2s ease-in-out",
                }}
              />
            </div>
          </>
        </Container>
      ) : null}
    </>
  );
}
